import cn from "classnames";

import { brown } from "@/app/font";
import { Text } from "@/components/text/text.component";

export const QuizStepper = ({ steps, activeStepIndex }: QuizStepperProps) => {
  if (!steps?.length) return null;

  return (
    <div data-testid="quiz-stepper" className="w-full">
      <div className="hidden w-full gap-6 md:flex">
        {steps.map((label, index) => {
          const isActive = index === activeStepIndex;

          return (
            <div
              key={index}
              data-testid={`quiz-step-${index}`}
              className="relative flex-1 pb-3">
              <Text
                variant="body3"
                className={cn(`${brown.className} font-bold uppercase`, {
                  "text-secondary": isActive,
                  "text-greyscale-strength": !isActive,
                })}>
                STEP {index + 1}
              </Text>
              <Text
                variant="body4"
                className={cn("mt-0.5", {
                  "text-greyscale-body": isActive,
                  "text-greyscale-strength": !isActive,
                })}>
                {label}
              </Text>
              <div
                className={cn("absolute bottom-0 left-0 h-0.5 w-full", {
                  "from-secondary to-primary bg-linear-to-r": isActive,
                  "bg-greyscale-strength/30": !isActive,
                })}
              />
            </div>
          );
        })}
      </div>

      <div className="md:hidden">
        <div className="flex w-full gap-1">
          {steps.map((_, index) => {
            const isActive = index === activeStepIndex;

            return (
              <div
                key={index}
                data-testid={`quiz-mobile-step-${index}`}
                className={cn("h-0.5 flex-1 transition-all duration-300", {
                  "from-secondary to-primary bg-linear-to-r": isActive,
                  "bg-greyscale-strength/30": !isActive,
                })}
              />
            );
          })}
        </div>
        <div className="mt-3 text-center">
          <Text
            variant="body3"
            className={`${brown.className} text-secondary font-bold uppercase`}>
            STEP {activeStepIndex + 1}
          </Text>
          <Text variant="body4" className="text-greyscale-body mt-0.5">
            {steps[activeStepIndex]}
          </Text>
        </div>
      </div>
    </div>
  );
};

type QuizStepperProps = {
  steps: string[];
  activeStepIndex: number;
};
